

const defaultProfileUrl = "https://img.freepik.com/premium-vector/profile-picture-placeholder-avatar-silhouette-gray-tones-icon-colored-shapes-gradient_1076610-40164.jpg?semt=ais_hybrid&w=740"
const defaultPostUrl = "https://us.123rf.com/450wm/pavelstasevich/pavelstasevich1811/pavelstasevich181101030/127533128-%EC%82%AC%EC%9A%A9-%EA%B0%80%EB%8A%A5%ED%95%9C-%EC%9D%B4%EB%AF%B8%EC%A7%80-%EC%95%84%EC%9D%B4%EC%BD%98%EC%9D%B4-%EC%97%86%EC%8A%B5%EB%8B%88%EB%8B%A4-%ED%8F%89%EB%A9%B4-%EB%B2%A1%ED%84%B0.jpg?ver=6"

const url = {
    defaultProfileUrl, 
    defaultPostUrl}

export default url;